import { useDispatch } from 'react-redux';
import { SubscriptionIntegratedSolutionInputDto, SubscriptionIntegratedSolutionOutputDto } from '@api/izibizi-xp';
import { UseFetchHookOutput } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useFetch } from '@hooks';
import { saveSuccessServiceResponse, saveUserInput } from '@store';

export const useFetchSubscriptionIntegratedSolution = (): UseFetchHookOutput<
	Omit<SubscriptionIntegratedSolutionInputDto, 'metadata'>,
	SubscriptionIntegratedSolutionOutputDto
> => {
	const dispatch = useDispatch();

	return useFetch<SubscriptionIntegratedSolutionInputDto, SubscriptionIntegratedSolutionOutputDto>({
		operationKey: 'subscriptionIntegratedSolution',
		withLoading: false,
		onSuccess: (res) => {
			if (res) {
				dispatch(saveSuccessServiceResponse({ subscriptionIntegratedSolution: res.data }));
				dispatch(saveUserInput({ hasIntegratedSolution: true }));
			}
		},
	});
};
